import { MakeCall } from 'ha/services/apiV2/createMakeCall';

// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';
import { UserDocument, UserDocumentCategory } from './types/UserDocument';

export default (makeCall: MakeCall) => (
  userId: 'me' | number,
  docUUID: string,
  data: {
    title?: string;
    filename?: string;
    category?: UserDocumentCategory;
  },
) =>
  makeCall<UserDocument>(
    'PUT',
    `${APIV2_URL}/user/${userId}/document/${docUUID}`,
    {
      data,
    },
  );
